export const INPUT_MAX_WIDTH = '650px'
